/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Api
 * VaultDXB API specification
 * OpenAPI spec version: 0.1.0
 */
import * as zod from "zod";

/**
 * @summary Health check
 */
export const HealthCheckResponse = zod.object({
  status: zod.string(),
});

/**
 * @summary Register a new user
 */
export const RegisterBody = zod.object({
  name: zod.string(),
  email: zod.string(),
  password: zod.string(),
  phone: zod.string().optional(),
  role: zod.enum(["broker", "investor"]),
});

/**
 * @summary Login
 */
export const LoginBody = zod.object({
  email: zod.string(),
  password: zod.string(),
});

export const LoginResponse = zod.object({
  token: zod.string(),
  user: zod.object({
    id: zod.number(),
    name: zod.string(),
    email: zod.string(),
    phone: zod.string().nullish(),
    role: zod.enum(["admin", "broker", "investor"]),
    membership: zod.enum(["free", "vip", "elite"]),
    status: zod.enum(["pending", "approved", "rejected"]),
    paymentStatus: zod.enum(["unpaid", "pending", "paid", "failed"]),
    stripeCustomerId: zod.string().nullish(),
    createdAt: zod.coerce.date(),
  }),
});

/**
 * @summary Get current user
 */
export const GetMeResponse = zod.object({
  id: zod.number(),
  name: zod.string(),
  email: zod.string(),
  phone: zod.string().nullish(),
  role: zod.enum(["admin", "broker", "investor"]),
  membership: zod.enum(["free", "vip", "elite"]),
  status: zod.enum(["pending", "approved", "rejected"]),
  paymentStatus: zod.enum(["unpaid", "pending", "paid", "failed"]),
  stripeCustomerId: zod.string().nullish(),
  createdAt: zod.coerce.date(),
});

/**
 * @summary List deals (investors see approved; brokers see own; admin sees all)
 */
export const ListDealsQueryParams = zod.object({
  area: zod.coerce.string().optional(),
  minDiscount: zod.coerce.number().optional(),
  minUrgency: zod.coerce.number().optional(),
  maxPrice: zod.coerce.number().optional(),
  unitType: zod.coerce.string().optional(),
  status: zod.enum(["pending", "approved", "rejected"]).optional(),
});

export const ListDealsResponseItem = zod.object({
  id: zod.number(),
  title: zod.string(),
  area: zod.string(),
  building: zod.string().nullish(),
  unitType: zod.string().nullish(),
  bedrooms: zod.number().nullish(),
  bathrooms: zod.number().nullish(),
  sizeSqft: zod.number().nullish(),
  askingPrice: zod.number(),
  estimatedMarketPrice: zod.number(),
  discountPercentage: zod.number().nullish(),
  urgencyScore: zod.number().nullish(),
  urgencyReason: zod.string().nullish(),
  sellerTimeline: zod.string().nullish(),
  propertyStatus: zod.string().nullish(),
  paymentPlanDetails: zod.string().nullish(),
  brokerContact: zod.string().nullish(),
  imageUrl: zod.string().nullish(),
  submittedByUserId: zod.number().nullish(),
  roiYield: zod.number().nullish(),
  developer: zod.string().nullish(),
  handoverStatus: zod.string().nullish(),
  sellerType: zod
    .enum(["owner", "broker", "developer", "distressed_seller"])
    .nullish(),
  dealCategory: zod
    .enum([
      "off_market",
      "distress_deal",
      "auction",
      "exclusive",
      "investor_only",
    ])
    .nullish(),
  description: zod.string().nullish(),
  visibility: zod.enum(["investors_only", "brokers_only", "both"]).nullish(),
  imageUrls: zod.string().nullish(),
  documentUrls: zod.string().nullish(),
  status: zod.enum(["draft", "pending", "approved", "rejected"]),
  isVipOnly: zod.boolean(),
  createdAt: zod.coerce.date(),
  submittedBy: zod
    .object({
      id: zod.number(),
      name: zod.string(),
      email: zod.string(),
      phone: zod.string().nullish(),
      role: zod.enum(["admin", "broker", "investor"]),
      membership: zod.enum(["free", "vip", "elite"]),
      status: zod.enum(["pending", "approved", "rejected"]),
      paymentStatus: zod.enum(["unpaid", "pending", "paid", "failed"]),
      stripeCustomerId: zod.string().nullish(),
      createdAt: zod.coerce.date(),
    })
    .nullish(),
  aiDistressScore: zod.number().nullish(),
  aiDealScore: zod.number().nullish(),
  aiInvestorAppeal: zod.enum(["High", "Medium", "Low"]).nullish(),
  aiRiskLevel: zod.enum(["High", "Medium", "Low"]).nullish(),
  aiRecommendedAction: zod.enum(["Prioritize", "Verify", "Reject"]).nullish(),
  aiInvestorSummary: zod.string().nullish(),
  aiRiskFlags: zod.string().nullish(),
  aiRecommendedBuyerType: zod.string().nullish(),
  aiLiquidityRating: zod.enum(["Low", "Medium", "High"]).nullish(),
  aiNegotiationAngle: zod.string().nullish(),
  aiMissingInfo: zod.string().nullish(),
  aiPricingComment: zod.string().nullish(),
  aiAdminDecision: zod.enum(["Approve", "Review", "Reject"]).nullish(),
});
export const ListDealsResponse = zod.array(ListDealsResponseItem);

/**
 * @summary Submit a new deal (broker only)
 */
export const CreateDealBody = zod.object({
  title: zod.string(),
  area: zod.string(),
  building: zod.string().optional(),
  unitType: zod.string().optional(),
  bedrooms: zod.number().optional(),
  bathrooms: zod.number().optional(),
  sizeSqft: zod.number().optional(),
  askingPrice: zod.number(),
  estimatedMarketPrice: zod.number(),
  roiYield: zod.number().optional(),
  urgencyReason: zod.string().optional(),
  sellerTimeline: zod.string().optional(),
  propertyStatus: zod.string().optional(),
  paymentPlanDetails: zod.string().optional(),
  brokerContact: zod.string().optional(),
  imageUrl: zod.string().optional(),
  imageUrls: zod.string().optional(),
  documentUrls: zod.string().optional(),
  developer: zod.string().optional(),
  handoverStatus: zod.string().optional(),
  sellerType: zod
    .enum(["owner", "broker", "developer", "distressed_seller"])
    .optional(),
  dealCategory: zod
    .enum([
      "off_market",
      "distress_deal",
      "auction",
      "exclusive",
      "investor_only",
    ])
    .optional(),
  description: zod.string().optional(),
  visibility: zod.enum(["investors_only", "brokers_only", "both"]).optional(),
  isVipOnly: zod.boolean().optional(),
  status: zod.enum(["draft", "pending", "approved", "rejected"]).optional(),
});

/**
 * @summary Get deal details
 */
export const GetDealParams = zod.object({
  id: zod.coerce.number(),
});

export const GetDealResponse = zod.object({
  id: zod.number(),
  title: zod.string(),
  area: zod.string(),
  building: zod.string().nullish(),
  unitType: zod.string().nullish(),
  bedrooms: zod.number().nullish(),
  bathrooms: zod.number().nullish(),
  sizeSqft: zod.number().nullish(),
  askingPrice: zod.number(),
  estimatedMarketPrice: zod.number(),
  discountPercentage: zod.number().nullish(),
  urgencyScore: zod.number().nullish(),
  urgencyReason: zod.string().nullish(),
  sellerTimeline: zod.string().nullish(),
  propertyStatus: zod.string().nullish(),
  paymentPlanDetails: zod.string().nullish(),
  brokerContact: zod.string().nullish(),
  imageUrl: zod.string().nullish(),
  submittedByUserId: zod.number().nullish(),
  roiYield: zod.number().nullish(),
  developer: zod.string().nullish(),
  handoverStatus: zod.string().nullish(),
  sellerType: zod
    .enum(["owner", "broker", "developer", "distressed_seller"])
    .nullish(),
  dealCategory: zod
    .enum([
      "off_market",
      "distress_deal",
      "auction",
      "exclusive",
      "investor_only",
    ])
    .nullish(),
  description: zod.string().nullish(),
  visibility: zod.enum(["investors_only", "brokers_only", "both"]).nullish(),
  imageUrls: zod.string().nullish(),
  documentUrls: zod.string().nullish(),
  status: zod.enum(["draft", "pending", "approved", "rejected"]),
  isVipOnly: zod.boolean(),
  createdAt: zod.coerce.date(),
  submittedBy: zod
    .object({
      id: zod.number(),
      name: zod.string(),
      email: zod.string(),
      phone: zod.string().nullish(),
      role: zod.enum(["admin", "broker", "investor"]),
      membership: zod.enum(["free", "vip", "elite"]),
      status: zod.enum(["pending", "approved", "rejected"]),
      paymentStatus: zod.enum(["unpaid", "pending", "paid", "failed"]),
      stripeCustomerId: zod.string().nullish(),
      createdAt: zod.coerce.date(),
    })
    .nullish(),
  aiDistressScore: zod.number().nullish(),
  aiDealScore: zod.number().nullish(),
  aiInvestorAppeal: zod.enum(["High", "Medium", "Low"]).nullish(),
  aiRiskLevel: zod.enum(["High", "Medium", "Low"]).nullish(),
  aiRecommendedAction: zod.enum(["Prioritize", "Verify", "Reject"]).nullish(),
  aiInvestorSummary: zod.string().nullish(),
  aiRiskFlags: zod.string().nullish(),
  aiRecommendedBuyerType: zod.string().nullish(),
  aiLiquidityRating: zod.enum(["Low", "Medium", "High"]).nullish(),
  aiNegotiationAngle: zod.string().nullish(),
  aiMissingInfo: zod.string().nullish(),
  aiPricingComment: zod.string().nullish(),
  aiAdminDecision: zod.enum(["Approve", "Review", "Reject"]).nullish(),
});

/**
 * @summary Update a deal (admin or deal owner broker)
 */
export const UpdateDealParams = zod.object({
  id: zod.coerce.number(),
});

export const UpdateDealBody = zod.object({
  title: zod.string().optional(),
  area: zod.string().optional(),
  building: zod.string().optional(),
  unitType: zod.string().optional(),
  bedrooms: zod.number().optional(),
  bathrooms: zod.number().optional(),
  sizeSqft: zod.number().optional(),
  askingPrice: zod.number().optional(),
  estimatedMarketPrice: zod.number().optional(),
  roiYield: zod.number().optional(),
  urgencyReason: zod.string().optional(),
  sellerTimeline: zod.string().optional(),
  propertyStatus: zod.string().optional(),
  paymentPlanDetails: zod.string().optional(),
  brokerContact: zod.string().optional(),
  imageUrl: zod.string().optional(),
  imageUrls: zod.string().optional(),
  documentUrls: zod.string().optional(),
  developer: zod.string().optional(),
  handoverStatus: zod.string().optional(),
  sellerType: zod
    .enum(["owner", "broker", "developer", "distressed_seller"])
    .optional(),
  dealCategory: zod
    .enum([
      "off_market",
      "distress_deal",
      "auction",
      "exclusive",
      "investor_only",
    ])
    .optional(),
  description: zod.string().optional(),
  visibility: zod.enum(["investors_only", "brokers_only", "both"]).optional(),
  isVipOnly: zod.boolean().optional(),
  status: zod.enum(["draft", "pending", "approved", "rejected"]).optional(),
  aiDistressScore: zod.number().nullish(),
  aiInvestorSummary: zod.string().nullish(),
  aiRiskFlags: zod.string().nullish(),
  aiRecommendedBuyerType: zod.string().nullish(),
  aiLiquidityRating: zod.enum(["Low", "Medium", "High"]).nullish(),
  aiNegotiationAngle: zod.string().nullish(),
});

export const UpdateDealResponse = zod.object({
  id: zod.number(),
  title: zod.string(),
  area: zod.string(),
  building: zod.string().nullish(),
  unitType: zod.string().nullish(),
  bedrooms: zod.number().nullish(),
  bathrooms: zod.number().nullish(),
  sizeSqft: zod.number().nullish(),
  askingPrice: zod.number(),
  estimatedMarketPrice: zod.number(),
  discountPercentage: zod.number().nullish(),
  urgencyScore: zod.number().nullish(),
  urgencyReason: zod.string().nullish(),
  sellerTimeline: zod.string().nullish(),
  propertyStatus: zod.string().nullish(),
  paymentPlanDetails: zod.string().nullish(),
  brokerContact: zod.string().nullish(),
  imageUrl: zod.string().nullish(),
  submittedByUserId: zod.number().nullish(),
  roiYield: zod.number().nullish(),
  developer: zod.string().nullish(),
  handoverStatus: zod.string().nullish(),
  sellerType: zod
    .enum(["owner", "broker", "developer", "distressed_seller"])
    .nullish(),
  dealCategory: zod
    .enum([
      "off_market",
      "distress_deal",
      "auction",
      "exclusive",
      "investor_only",
    ])
    .nullish(),
  description: zod.string().nullish(),
  visibility: zod.enum(["investors_only", "brokers_only", "both"]).nullish(),
  imageUrls: zod.string().nullish(),
  documentUrls: zod.string().nullish(),
  status: zod.enum(["draft", "pending", "approved", "rejected"]),
  isVipOnly: zod.boolean(),
  createdAt: zod.coerce.date(),
  submittedBy: zod
    .object({
      id: zod.number(),
      name: zod.string(),
      email: zod.string(),
      phone: zod.string().nullish(),
      role: zod.enum(["admin", "broker", "investor"]),
      membership: zod.enum(["free", "vip", "elite"]),
      status: zod.enum(["pending", "approved", "rejected"]),
      paymentStatus: zod.enum(["unpaid", "pending", "paid", "failed"]),
      stripeCustomerId: zod.string().nullish(),
      createdAt: zod.coerce.date(),
    })
    .nullish(),
  aiDistressScore: zod.number().nullish(),
  aiDealScore: zod.number().nullish(),
  aiInvestorAppeal: zod.enum(["High", "Medium", "Low"]).nullish(),
  aiRiskLevel: zod.enum(["High", "Medium", "Low"]).nullish(),
  aiRecommendedAction: zod.enum(["Prioritize", "Verify", "Reject"]).nullish(),
  aiInvestorSummary: zod.string().nullish(),
  aiRiskFlags: zod.string().nullish(),
  aiRecommendedBuyerType: zod.string().nullish(),
  aiLiquidityRating: zod.enum(["Low", "Medium", "High"]).nullish(),
  aiNegotiationAngle: zod.string().nullish(),
  aiMissingInfo: zod.string().nullish(),
  aiPricingComment: zod.string().nullish(),
  aiAdminDecision: zod.enum(["Approve", "Review", "Reject"]).nullish(),
});

/**
 * @summary Delete a deal (admin only)
 */
export const DeleteDealParams = zod.object({
  id: zod.coerce.number(),
});

/**
 * @summary Approve a deal (admin only)
 */
export const ApproveDealParams = zod.object({
  id: zod.coerce.number(),
});

export const ApproveDealResponse = zod.object({
  id: zod.number(),
  title: zod.string(),
  area: zod.string(),
  building: zod.string().nullish(),
  unitType: zod.string().nullish(),
  bedrooms: zod.number().nullish(),
  bathrooms: zod.number().nullish(),
  sizeSqft: zod.number().nullish(),
  askingPrice: zod.number(),
  estimatedMarketPrice: zod.number(),
  discountPercentage: zod.number().nullish(),
  urgencyScore: zod.number().nullish(),
  urgencyReason: zod.string().nullish(),
  sellerTimeline: zod.string().nullish(),
  propertyStatus: zod.string().nullish(),
  paymentPlanDetails: zod.string().nullish(),
  brokerContact: zod.string().nullish(),
  imageUrl: zod.string().nullish(),
  submittedByUserId: zod.number().nullish(),
  roiYield: zod.number().nullish(),
  developer: zod.string().nullish(),
  handoverStatus: zod.string().nullish(),
  sellerType: zod
    .enum(["owner", "broker", "developer", "distressed_seller"])
    .nullish(),
  dealCategory: zod
    .enum([
      "off_market",
      "distress_deal",
      "auction",
      "exclusive",
      "investor_only",
    ])
    .nullish(),
  description: zod.string().nullish(),
  visibility: zod.enum(["investors_only", "brokers_only", "both"]).nullish(),
  imageUrls: zod.string().nullish(),
  documentUrls: zod.string().nullish(),
  status: zod.enum(["draft", "pending", "approved", "rejected"]),
  isVipOnly: zod.boolean(),
  createdAt: zod.coerce.date(),
  submittedBy: zod
    .object({
      id: zod.number(),
      name: zod.string(),
      email: zod.string(),
      phone: zod.string().nullish(),
      role: zod.enum(["admin", "broker", "investor"]),
      membership: zod.enum(["free", "vip", "elite"]),
      status: zod.enum(["pending", "approved", "rejected"]),
      paymentStatus: zod.enum(["unpaid", "pending", "paid", "failed"]),
      stripeCustomerId: zod.string().nullish(),
      createdAt: zod.coerce.date(),
    })
    .nullish(),
  aiDistressScore: zod.number().nullish(),
  aiDealScore: zod.number().nullish(),
  aiInvestorAppeal: zod.enum(["High", "Medium", "Low"]).nullish(),
  aiRiskLevel: zod.enum(["High", "Medium", "Low"]).nullish(),
  aiRecommendedAction: zod.enum(["Prioritize", "Verify", "Reject"]).nullish(),
  aiInvestorSummary: zod.string().nullish(),
  aiRiskFlags: zod.string().nullish(),
  aiRecommendedBuyerType: zod.string().nullish(),
  aiLiquidityRating: zod.enum(["Low", "Medium", "High"]).nullish(),
  aiNegotiationAngle: zod.string().nullish(),
  aiMissingInfo: zod.string().nullish(),
  aiPricingComment: zod.string().nullish(),
  aiAdminDecision: zod.enum(["Approve", "Review", "Reject"]).nullish(),
});

/**
 * @summary Reject a deal (admin only)
 */
export const RejectDealParams = zod.object({
  id: zod.coerce.number(),
});

export const RejectDealResponse = zod.object({
  id: zod.number(),
  title: zod.string(),
  area: zod.string(),
  building: zod.string().nullish(),
  unitType: zod.string().nullish(),
  bedrooms: zod.number().nullish(),
  bathrooms: zod.number().nullish(),
  sizeSqft: zod.number().nullish(),
  askingPrice: zod.number(),
  estimatedMarketPrice: zod.number(),
  discountPercentage: zod.number().nullish(),
  urgencyScore: zod.number().nullish(),
  urgencyReason: zod.string().nullish(),
  sellerTimeline: zod.string().nullish(),
  propertyStatus: zod.string().nullish(),
  paymentPlanDetails: zod.string().nullish(),
  brokerContact: zod.string().nullish(),
  imageUrl: zod.string().nullish(),
  submittedByUserId: zod.number().nullish(),
  roiYield: zod.number().nullish(),
  developer: zod.string().nullish(),
  handoverStatus: zod.string().nullish(),
  sellerType: zod
    .enum(["owner", "broker", "developer", "distressed_seller"])
    .nullish(),
  dealCategory: zod
    .enum([
      "off_market",
      "distress_deal",
      "auction",
      "exclusive",
      "investor_only",
    ])
    .nullish(),
  description: zod.string().nullish(),
  visibility: zod.enum(["investors_only", "brokers_only", "both"]).nullish(),
  imageUrls: zod.string().nullish(),
  documentUrls: zod.string().nullish(),
  status: zod.enum(["draft", "pending", "approved", "rejected"]),
  isVipOnly: zod.boolean(),
  createdAt: zod.coerce.date(),
  submittedBy: zod
    .object({
      id: zod.number(),
      name: zod.string(),
      email: zod.string(),
      phone: zod.string().nullish(),
      role: zod.enum(["admin", "broker", "investor"]),
      membership: zod.enum(["free", "vip", "elite"]),
      status: zod.enum(["pending", "approved", "rejected"]),
      paymentStatus: zod.enum(["unpaid", "pending", "paid", "failed"]),
      stripeCustomerId: zod.string().nullish(),
      createdAt: zod.coerce.date(),
    })
    .nullish(),
  aiDistressScore: zod.number().nullish(),
  aiDealScore: zod.number().nullish(),
  aiInvestorAppeal: zod.enum(["High", "Medium", "Low"]).nullish(),
  aiRiskLevel: zod.enum(["High", "Medium", "Low"]).nullish(),
  aiRecommendedAction: zod.enum(["Prioritize", "Verify", "Reject"]).nullish(),
  aiInvestorSummary: zod.string().nullish(),
  aiRiskFlags: zod.string().nullish(),
  aiRecommendedBuyerType: zod.string().nullish(),
  aiLiquidityRating: zod.enum(["Low", "Medium", "High"]).nullish(),
  aiNegotiationAngle: zod.string().nullish(),
  aiMissingInfo: zod.string().nullish(),
  aiPricingComment: zod.string().nullish(),
  aiAdminDecision: zod.enum(["Approve", "Review", "Reject"]).nullish(),
});

/**
 * @summary Deactivate a deal — moves it back to pending (admin only)
 */
export const DeactivateDealParams = zod.object({
  id: zod.coerce.number(),
});

export const DeactivateDealResponse = zod.object({
  id: zod.number(),
  title: zod.string(),
  area: zod.string(),
  building: zod.string().nullish(),
  unitType: zod.string().nullish(),
  bedrooms: zod.number().nullish(),
  bathrooms: zod.number().nullish(),
  sizeSqft: zod.number().nullish(),
  askingPrice: zod.number(),
  estimatedMarketPrice: zod.number(),
  discountPercentage: zod.number().nullish(),
  urgencyScore: zod.number().nullish(),
  urgencyReason: zod.string().nullish(),
  sellerTimeline: zod.string().nullish(),
  propertyStatus: zod.string().nullish(),
  paymentPlanDetails: zod.string().nullish(),
  brokerContact: zod.string().nullish(),
  imageUrl: zod.string().nullish(),
  submittedByUserId: zod.number().nullish(),
  roiYield: zod.number().nullish(),
  developer: zod.string().nullish(),
  handoverStatus: zod.string().nullish(),
  sellerType: zod
    .enum(["owner", "broker", "developer", "distressed_seller"])
    .nullish(),
  dealCategory: zod
    .enum([
      "off_market",
      "distress_deal",
      "auction",
      "exclusive",
      "investor_only",
    ])
    .nullish(),
  description: zod.string().nullish(),
  visibility: zod.enum(["investors_only", "brokers_only", "both"]).nullish(),
  imageUrls: zod.string().nullish(),
  documentUrls: zod.string().nullish(),
  status: zod.enum(["draft", "pending", "approved", "rejected"]),
  isVipOnly: zod.boolean(),
  createdAt: zod.coerce.date(),
  submittedBy: zod
    .object({
      id: zod.number(),
      name: zod.string(),
      email: zod.string(),
      phone: zod.string().nullish(),
      role: zod.enum(["admin", "broker", "investor"]),
      membership: zod.enum(["free", "vip", "elite"]),
      status: zod.enum(["pending", "approved", "rejected"]),
      paymentStatus: zod.enum(["unpaid", "pending", "paid", "failed"]),
      stripeCustomerId: zod.string().nullish(),
      createdAt: zod.coerce.date(),
    })
    .nullish(),
  aiDistressScore: zod.number().nullish(),
  aiDealScore: zod.number().nullish(),
  aiInvestorAppeal: zod.enum(["High", "Medium", "Low"]).nullish(),
  aiRiskLevel: zod.enum(["High", "Medium", "Low"]).nullish(),
  aiRecommendedAction: zod.enum(["Prioritize", "Verify", "Reject"]).nullish(),
  aiInvestorSummary: zod.string().nullish(),
  aiRiskFlags: zod.string().nullish(),
  aiRecommendedBuyerType: zod.string().nullish(),
  aiLiquidityRating: zod.enum(["Low", "Medium", "High"]).nullish(),
  aiNegotiationAngle: zod.string().nullish(),
  aiMissingInfo: zod.string().nullish(),
  aiPricingComment: zod.string().nullish(),
  aiAdminDecision: zod.enum(["Approve", "Review", "Reject"]).nullish(),
});

/**
 * @summary List access requests (admin sees all; investor sees own)
 */
export const ListAccessRequestsResponseItem = zod.object({
  id: zod.number(),
  dealId: zod.number(),
  investorUserId: zod.number(),
  message: zod.string().nullish(),
  status: zod.enum(["new", "contacted", "closed", "rejected"]),
  createdAt: zod.coerce.date(),
  deal: zod
    .object({
      id: zod.number(),
      title: zod.string(),
      area: zod.string(),
      building: zod.string().nullish(),
      unitType: zod.string().nullish(),
      bedrooms: zod.number().nullish(),
      bathrooms: zod.number().nullish(),
      sizeSqft: zod.number().nullish(),
      askingPrice: zod.number(),
      estimatedMarketPrice: zod.number(),
      discountPercentage: zod.number().nullish(),
      urgencyScore: zod.number().nullish(),
      urgencyReason: zod.string().nullish(),
      sellerTimeline: zod.string().nullish(),
      propertyStatus: zod.string().nullish(),
      paymentPlanDetails: zod.string().nullish(),
      brokerContact: zod.string().nullish(),
      imageUrl: zod.string().nullish(),
      submittedByUserId: zod.number().nullish(),
      roiYield: zod.number().nullish(),
      developer: zod.string().nullish(),
      handoverStatus: zod.string().nullish(),
      sellerType: zod
        .enum(["owner", "broker", "developer", "distressed_seller"])
        .nullish(),
      dealCategory: zod
        .enum([
          "off_market",
          "distress_deal",
          "auction",
          "exclusive",
          "investor_only",
        ])
        .nullish(),
      description: zod.string().nullish(),
      visibility: zod
        .enum(["investors_only", "brokers_only", "both"])
        .nullish(),
      imageUrls: zod.string().nullish(),
      documentUrls: zod.string().nullish(),
      status: zod.enum(["draft", "pending", "approved", "rejected"]),
      isVipOnly: zod.boolean(),
      createdAt: zod.coerce.date(),
      submittedBy: zod
        .object({
          id: zod.number(),
          name: zod.string(),
          email: zod.string(),
          phone: zod.string().nullish(),
          role: zod.enum(["admin", "broker", "investor"]),
          membership: zod.enum(["free", "vip", "elite"]),
          status: zod.enum(["pending", "approved", "rejected"]),
          paymentStatus: zod.enum(["unpaid", "pending", "paid", "failed"]),
          stripeCustomerId: zod.string().nullish(),
          createdAt: zod.coerce.date(),
        })
        .nullish(),
      aiDistressScore: zod.number().nullish(),
      aiDealScore: zod.number().nullish(),
      aiInvestorAppeal: zod.enum(["High", "Medium", "Low"]).nullish(),
      aiRiskLevel: zod.enum(["High", "Medium", "Low"]).nullish(),
      aiRecommendedAction: zod
        .enum(["Prioritize", "Verify", "Reject"])
        .nullish(),
      aiInvestorSummary: zod.string().nullish(),
      aiRiskFlags: zod.string().nullish(),
      aiRecommendedBuyerType: zod.string().nullish(),
      aiLiquidityRating: zod.enum(["Low", "Medium", "High"]).nullish(),
      aiNegotiationAngle: zod.string().nullish(),
      aiMissingInfo: zod.string().nullish(),
      aiPricingComment: zod.string().nullish(),
      aiAdminDecision: zod.enum(["Approve", "Review", "Reject"]).nullish(),
    })
    .nullish(),
  investor: zod
    .object({
      id: zod.number(),
      name: zod.string(),
      email: zod.string(),
      phone: zod.string().nullish(),
      role: zod.enum(["admin", "broker", "investor"]),
      membership: zod.enum(["free", "vip", "elite"]),
      status: zod.enum(["pending", "approved", "rejected"]),
      paymentStatus: zod.enum(["unpaid", "pending", "paid", "failed"]),
      stripeCustomerId: zod.string().nullish(),
      createdAt: zod.coerce.date(),
    })
    .nullish(),
});
export const ListAccessRequestsResponse = zod.array(
  ListAccessRequestsResponseItem,
);

/**
 * @summary Request access to a deal
 */
export const CreateAccessRequestBody = zod.object({
  dealId: zod.number(),
  message: zod.string().optional(),
});

/**
 * @summary Update access request status (admin only)
 */
export const UpdateAccessRequestParams = zod.object({
  id: zod.coerce.number(),
});

export const UpdateAccessRequestBody = zod.object({
  status: zod.enum(["new", "contacted", "closed", "rejected"]),
});

export const UpdateAccessRequestResponse = zod.object({
  id: zod.number(),
  dealId: zod.number(),
  investorUserId: zod.number(),
  message: zod.string().nullish(),
  status: zod.enum(["new", "contacted", "closed", "rejected"]),
  createdAt: zod.coerce.date(),
  deal: zod
    .object({
      id: zod.number(),
      title: zod.string(),
      area: zod.string(),
      building: zod.string().nullish(),
      unitType: zod.string().nullish(),
      bedrooms: zod.number().nullish(),
      bathrooms: zod.number().nullish(),
      sizeSqft: zod.number().nullish(),
      askingPrice: zod.number(),
      estimatedMarketPrice: zod.number(),
      discountPercentage: zod.number().nullish(),
      urgencyScore: zod.number().nullish(),
      urgencyReason: zod.string().nullish(),
      sellerTimeline: zod.string().nullish(),
      propertyStatus: zod.string().nullish(),
      paymentPlanDetails: zod.string().nullish(),
      brokerContact: zod.string().nullish(),
      imageUrl: zod.string().nullish(),
      submittedByUserId: zod.number().nullish(),
      roiYield: zod.number().nullish(),
      developer: zod.string().nullish(),
      handoverStatus: zod.string().nullish(),
      sellerType: zod
        .enum(["owner", "broker", "developer", "distressed_seller"])
        .nullish(),
      dealCategory: zod
        .enum([
          "off_market",
          "distress_deal",
          "auction",
          "exclusive",
          "investor_only",
        ])
        .nullish(),
      description: zod.string().nullish(),
      visibility: zod
        .enum(["investors_only", "brokers_only", "both"])
        .nullish(),
      imageUrls: zod.string().nullish(),
      documentUrls: zod.string().nullish(),
      status: zod.enum(["draft", "pending", "approved", "rejected"]),
      isVipOnly: zod.boolean(),
      createdAt: zod.coerce.date(),
      submittedBy: zod
        .object({
          id: zod.number(),
          name: zod.string(),
          email: zod.string(),
          phone: zod.string().nullish(),
          role: zod.enum(["admin", "broker", "investor"]),
          membership: zod.enum(["free", "vip", "elite"]),
          status: zod.enum(["pending", "approved", "rejected"]),
          paymentStatus: zod.enum(["unpaid", "pending", "paid", "failed"]),
          stripeCustomerId: zod.string().nullish(),
          createdAt: zod.coerce.date(),
        })
        .nullish(),
      aiDistressScore: zod.number().nullish(),
      aiDealScore: zod.number().nullish(),
      aiInvestorAppeal: zod.enum(["High", "Medium", "Low"]).nullish(),
      aiRiskLevel: zod.enum(["High", "Medium", "Low"]).nullish(),
      aiRecommendedAction: zod
        .enum(["Prioritize", "Verify", "Reject"])
        .nullish(),
      aiInvestorSummary: zod.string().nullish(),
      aiRiskFlags: zod.string().nullish(),
      aiRecommendedBuyerType: zod.string().nullish(),
      aiLiquidityRating: zod.enum(["Low", "Medium", "High"]).nullish(),
      aiNegotiationAngle: zod.string().nullish(),
      aiMissingInfo: zod.string().nullish(),
      aiPricingComment: zod.string().nullish(),
      aiAdminDecision: zod.enum(["Approve", "Review", "Reject"]).nullish(),
    })
    .nullish(),
  investor: zod
    .object({
      id: zod.number(),
      name: zod.string(),
      email: zod.string(),
      phone: zod.string().nullish(),
      role: zod.enum(["admin", "broker", "investor"]),
      membership: zod.enum(["free", "vip", "elite"]),
      status: zod.enum(["pending", "approved", "rejected"]),
      paymentStatus: zod.enum(["unpaid", "pending", "paid", "failed"]),
      stripeCustomerId: zod.string().nullish(),
      createdAt: zod.coerce.date(),
    })
    .nullish(),
});

/**
 * @summary Create a Stripe checkout session
 */
export const CreateCheckoutSessionBody = zod.object({
  plan: zod.enum([
    "vip",
    "elite",
    "verified_broker",
    "urgent_seller",
    "concierge_sale",
  ]),
  successUrl: zod.string().optional(),
  cancelUrl: zod.string().optional(),
});

export const CreateCheckoutSessionResponse = zod.object({
  url: zod.string().nullish(),
  sessionId: zod.string(),
});

/**
 * @summary Get admin dashboard stats
 */
export const GetAdminStatsResponse = zod.object({
  totalDeals: zod.number(),
  pendingDeals: zod.number(),
  approvedDeals: zod.number(),
  rejectedDeals: zod.number(),
  totalInvestors: zod.number(),
  pendingInvestors: zod.number(),
  totalBrokers: zod.number(),
  pendingBrokers: zod.number(),
  totalAccessRequests: zod.number(),
  activeDealRooms: zod.number().optional(),
  totalBidsSubmitted: zod.number().optional(),
  shortlistedBids: zod.number().optional(),
  closedDealRooms: zod.number().optional(),
  vipUsers: zod.number(),
  eliteUsers: zod.number(),
  totalSellerLeads: zod.number(),
  newSellerLeads: zod.number(),
});

/**
 * @summary List all users (admin only)
 */
export const ListUsersResponseItem = zod.object({
  id: zod.number(),
  name: zod.string(),
  email: zod.string(),
  phone: zod.string().nullish(),
  role: zod.enum(["admin", "broker", "investor"]),
  membership: zod.enum(["free", "vip", "elite"]),
  status: zod.enum(["pending", "approved", "rejected"]),
  paymentStatus: zod.enum(["unpaid", "pending", "paid", "failed"]),
  stripeCustomerId: zod.string().nullish(),
  createdAt: zod.coerce.date(),
});
export const ListUsersResponse = zod.array(ListUsersResponseItem);

/**
 * @summary Update user membership/role (admin only)
 */
export const UpdateUserParams = zod.object({
  id: zod.coerce.number(),
});

export const UpdateUserBody = zod.object({
  membership: zod.enum(["free", "vip", "elite"]).optional(),
  role: zod.enum(["admin", "broker", "investor"]).optional(),
  status: zod.enum(["pending", "approved", "rejected"]).optional(),
  paymentStatus: zod.enum(["unpaid", "pending", "paid", "failed"]).optional(),
});

export const UpdateUserResponse = zod.object({
  id: zod.number(),
  name: zod.string(),
  email: zod.string(),
  phone: zod.string().nullish(),
  role: zod.enum(["admin", "broker", "investor"]),
  membership: zod.enum(["free", "vip", "elite"]),
  status: zod.enum(["pending", "approved", "rejected"]),
  paymentStatus: zod.enum(["unpaid", "pending", "paid", "failed"]),
  stripeCustomerId: zod.string().nullish(),
  createdAt: zod.coerce.date(),
});

/**
 * @summary Run AI analysis on a deal (admin only)
 */
export const AnalyzeDealBody = zod.object({
  dealId: zod.number(),
});

export const AnalyzeDealResponse = zod.object({
  dealId: zod.number(),
  aiDistressScore: zod.number(),
  aiDealScore: zod.number(),
  aiInvestorAppeal: zod.enum(["High", "Medium", "Low"]),
  aiRiskLevel: zod.enum(["High", "Medium", "Low"]),
  aiRecommendedAction: zod.enum(["Prioritize", "Verify", "Reject"]),
  aiInvestorSummary: zod.string(),
  aiRiskFlags: zod.string(),
  aiRecommendedBuyerType: zod.string(),
  aiLiquidityRating: zod.enum(["Low", "Medium", "High"]),
  aiNegotiationAngle: zod.string(),
  aiMissingInfo: zod.string(),
  aiPricingComment: zod.string(),
  aiAdminDecision: zod.enum(["Approve", "Review", "Reject"]),
});

/**
 * @summary Run AI qualification on a seller lead (admin only)
 */
export const AnalyzeSellerLeadBody = zod.object({
  leadId: zod.number(),
});

export const AnalyzeSellerLeadResponse = zod.object({
  leadId: zod.number(),
  aiLeadTemperature: zod.enum(["Hot", "Warm", "Cold"]),
  aiUrgencyScore: zod.number(),
  aiLikelyMotivation: zod.string(),
  aiSuggestedAgentScript: zod.string(),
  aiRecommendedNextStep: zod.string(),
});

/**
 * @summary AI Broker Assistant — improve description, generate pitch, or check attractiveness
 */
export const BrokerAssistBody = zod.object({
  title: zod.string(),
  area: zod.string(),
  unitType: zod.string().optional(),
  bedrooms: zod.number().optional(),
  bathrooms: zod.number().optional(),
  sizeSqft: zod.number().optional(),
  askingPrice: zod.number(),
  estimatedMarketPrice: zod.number(),
  urgencyReason: zod.string().optional(),
  sellerTimeline: zod.string().optional(),
  propertyStatus: zod.string().optional(),
  mode: zod.enum([
    "improve_description",
    "generate_pitch",
    "check_attractiveness",
  ]),
});

export const BrokerAssistResponse = zod.object({
  mode: zod.string(),
  result: zod.string(),
  attractivenessScore: zod.number().nullish(),
});

/**
 * @summary Get investors matched to a deal (admin only)
 */
export const GetMatchedInvestorsParams = zod.object({
  id: zod.coerce.number(),
});

export const GetMatchedInvestorsResponse = zod.object({
  dealId: zod.number(),
  matchedCount: zod.number(),
  investors: zod.array(
    zod.object({
      id: zod.number(),
      name: zod.string(),
      email: zod.string(),
      membership: zod.string(),
      matchScore: zod.number(),
    }),
  ),
});

/**
 * @summary List deal rooms (investor sees accessible rooms; admin sees all)
 */
export const ListDealRoomsResponseItem = zod.object({
  id: zod.number(),
  title: zod.string(),
  description: zod.string().nullish(),
  startTime: zod.coerce.date(),
  endTime: zod.coerce.date(),
  status: zod.enum(["upcoming", "live", "closed"]),
  accessLevel: zod.enum(["vip", "elite", "invite_only"]),
  createdAt: zod.coerce.date(),
  itemCount: zod.number(),
  bidCount: zod.number(),
});
export const ListDealRoomsResponse = zod.array(ListDealRoomsResponseItem);

/**
 * @summary Get deal room with items
 */
export const GetDealRoomParams = zod.object({
  id: zod.coerce.number(),
});

export const GetDealRoomResponse = zod.object({
  id: zod.number(),
  title: zod.string(),
  description: zod.string().nullish(),
  startTime: zod.coerce.date(),
  endTime: zod.coerce.date(),
  status: zod.enum(["upcoming", "live", "closed"]),
  accessLevel: zod.enum(["vip", "elite", "invite_only"]),
  createdAt: zod.coerce.date(),
  itemCount: zod.number(),
  bidCount: zod.number(),
  items: zod.array(
    zod.object({
      id: zod.number(),
      dealRoomId: zod.number(),
      dealId: zod.number(),
      reservePrice: zod.number().nullish(),
      minimumOffer: zod.number().nullish(),
      sellerTerms: zod.string().nullish(),
      closingTimeline: zod.string().nullish(),
      createdAt: zod.coerce.date(),
      deal: zod.object({
        id: zod.number(),
        title: zod.string(),
        area: zod.string(),
        building: zod.string().nullish(),
        unitType: zod.string().nullish(),
        bedrooms: zod.number().nullish(),
        bathrooms: zod.number().nullish(),
        sizeSqft: zod.number().nullish(),
        askingPrice: zod.number(),
        estimatedMarketPrice: zod.number(),
        discountPercentage: zod.number().nullish(),
        urgencyScore: zod.number().nullish(),
        urgencyReason: zod.string().nullish(),
        sellerTimeline: zod.string().nullish(),
        propertyStatus: zod.string().nullish(),
        paymentPlanDetails: zod.string().nullish(),
        brokerContact: zod.string().nullish(),
        imageUrl: zod.string().nullish(),
        submittedByUserId: zod.number().nullish(),
        roiYield: zod.number().nullish(),
        developer: zod.string().nullish(),
        handoverStatus: zod.string().nullish(),
        sellerType: zod
          .enum(["owner", "broker", "developer", "distressed_seller"])
          .nullish(),
        dealCategory: zod
          .enum([
            "off_market",
            "distress_deal",
            "auction",
            "exclusive",
            "investor_only",
          ])
          .nullish(),
        description: zod.string().nullish(),
        visibility: zod
          .enum(["investors_only", "brokers_only", "both"])
          .nullish(),
        imageUrls: zod.string().nullish(),
        documentUrls: zod.string().nullish(),
        status: zod.enum(["draft", "pending", "approved", "rejected"]),
        isVipOnly: zod.boolean(),
        createdAt: zod.coerce.date(),
        submittedBy: zod
          .object({
            id: zod.number(),
            name: zod.string(),
            email: zod.string(),
            phone: zod.string().nullish(),
            role: zod.enum(["admin", "broker", "investor"]),
            membership: zod.enum(["free", "vip", "elite"]),
            status: zod.enum(["pending", "approved", "rejected"]),
            paymentStatus: zod.enum(["unpaid", "pending", "paid", "failed"]),
            stripeCustomerId: zod.string().nullish(),
            createdAt: zod.coerce.date(),
          })
          .nullish(),
        aiDistressScore: zod.number().nullish(),
        aiDealScore: zod.number().nullish(),
        aiInvestorAppeal: zod.enum(["High", "Medium", "Low"]).nullish(),
        aiRiskLevel: zod.enum(["High", "Medium", "Low"]).nullish(),
        aiRecommendedAction: zod
          .enum(["Prioritize", "Verify", "Reject"])
          .nullish(),
        aiInvestorSummary: zod.string().nullish(),
        aiRiskFlags: zod.string().nullish(),
        aiRecommendedBuyerType: zod.string().nullish(),
        aiLiquidityRating: zod.enum(["Low", "Medium", "High"]).nullish(),
        aiNegotiationAngle: zod.string().nullish(),
        aiMissingInfo: zod.string().nullish(),
        aiPricingComment: zod.string().nullish(),
        aiAdminDecision: zod.enum(["Approve", "Review", "Reject"]).nullish(),
      }),
      bidCount: zod.number(),
      hasHighInterest: zod.boolean(),
    }),
  ),
});

/**
 * @summary Submit a confidential offer in a deal room (investor only)
 */
export const SubmitBidParams = zod.object({
  id: zod.coerce.number(),
});

export const SubmitBidBody = zod.object({
  dealId: zod.number(),
  offerAmount: zod.number(),
  message: zod.string().optional(),
  proofOfFundsUrl: zod.string().optional(),
});

/**
 * @summary Get the current investor's bid for a deal room item
 */
export const GetMyBidParams = zod.object({
  id: zod.coerce.number(),
});

export const GetMyBidQueryParams = zod.object({
  dealId: zod.coerce.number(),
});

export const GetMyBidResponse = zod.object({
  id: zod.number(),
  dealRoomId: zod.number(),
  dealId: zod.number(),
  investorUserId: zod.number(),
  offerAmount: zod.number(),
  message: zod.string().nullish(),
  proofOfFundsUrl: zod.string().nullish(),
  status: zod.enum(["submitted", "shortlisted", "rejected", "accepted"]),
  createdAt: zod.coerce.date(),
});

/**
 * @summary List all deal rooms with stats (admin only)
 */
export const ListAdminDealRoomsResponseItem = zod.object({
  id: zod.number(),
  title: zod.string(),
  description: zod.string().nullish(),
  startTime: zod.coerce.date(),
  endTime: zod.coerce.date(),
  status: zod.enum(["upcoming", "live", "closed"]),
  accessLevel: zod.enum(["vip", "elite", "invite_only"]),
  createdAt: zod.coerce.date(),
  itemCount: zod.number(),
  bidCount: zod.number(),
});
export const ListAdminDealRoomsResponse = zod.array(
  ListAdminDealRoomsResponseItem,
);

/**
 * @summary Create a new deal room (admin only)
 */
export const CreateDealRoomBody = zod.object({
  title: zod.string(),
  description: zod.string().optional(),
  startTime: zod.coerce.date(),
  endTime: zod.coerce.date(),
  accessLevel: zod.enum(["vip", "elite", "invite_only"]),
});

/**
 * @summary Update a deal room (admin only)
 */
export const UpdateDealRoomParams = zod.object({
  id: zod.coerce.number(),
});

export const UpdateDealRoomBody = zod.object({
  title: zod.string().optional(),
  description: zod.string().optional(),
  startTime: zod.coerce.date().optional(),
  endTime: zod.coerce.date().optional(),
  status: zod.enum(["upcoming", "live", "closed"]).optional(),
  accessLevel: zod.enum(["vip", "elite", "invite_only"]).optional(),
});

export const UpdateDealRoomResponse = zod.object({
  id: zod.number(),
  title: zod.string(),
  description: zod.string().nullish(),
  startTime: zod.coerce.date(),
  endTime: zod.coerce.date(),
  status: zod.enum(["upcoming", "live", "closed"]),
  accessLevel: zod.enum(["vip", "elite", "invite_only"]),
  createdAt: zod.coerce.date(),
  itemCount: zod.number(),
  bidCount: zod.number(),
});

/**
 * @summary Add a deal to a deal room (admin only)
 */
export const AddDealRoomItemParams = zod.object({
  id: zod.coerce.number(),
});

export const AddDealRoomItemBody = zod.object({
  dealId: zod.number(),
  reservePrice: zod.number().optional(),
  minimumOffer: zod.number().optional(),
  sellerTerms: zod.string().optional(),
  closingTimeline: zod.string().optional(),
});

/**
 * @summary Remove a deal from a deal room (admin only)
 */
export const RemoveDealRoomItemParams = zod.object({
  id: zod.coerce.number(),
  itemId: zod.coerce.number(),
});

/**
 * @summary List all bids for a deal room (admin only)
 */
export const ListDealRoomBidsParams = zod.object({
  id: zod.coerce.number(),
});

export const ListDealRoomBidsResponseItem = zod.object({
  id: zod.number(),
  dealRoomId: zod.number(),
  dealId: zod.number(),
  investorUserId: zod.number(),
  offerAmount: zod.number(),
  message: zod.string().nullish(),
  proofOfFundsUrl: zod.string().nullish(),
  status: zod.enum(["submitted", "shortlisted", "rejected", "accepted"]),
  createdAt: zod.coerce.date(),
  investor: zod.object({
    id: zod.number(),
    name: zod.string(),
    email: zod.string(),
    membership: zod.string(),
  }),
  dealTitle: zod.string(),
});
export const ListDealRoomBidsResponse = zod.array(ListDealRoomBidsResponseItem);

/**
 * @summary Update bid status (admin only)
 */
export const UpdateBidParams = zod.object({
  id: zod.coerce.number(),
});

export const UpdateBidBody = zod.object({
  status: zod.enum(["submitted", "shortlisted", "rejected", "accepted"]),
});

export const UpdateBidResponse = zod.object({
  id: zod.number(),
  dealRoomId: zod.number(),
  dealId: zod.number(),
  investorUserId: zod.number(),
  offerAmount: zod.number(),
  message: zod.string().nullish(),
  proofOfFundsUrl: zod.string().nullish(),
  status: zod.enum(["submitted", "shortlisted", "rejected", "accepted"]),
  createdAt: zod.coerce.date(),
  investor: zod.object({
    id: zod.number(),
    name: zod.string(),
    email: zod.string(),
    membership: zod.string(),
  }),
  dealTitle: zod.string(),
});

/**
 * @summary Send a payment link to a seller (admin only)
 */
export const SendSellerPaymentLinkParams = zod.object({
  id: zod.coerce.number(),
});

export const SendSellerPaymentLinkBody = zod.object({
  plan: zod.enum(["urgent_seller", "concierge_sale"]),
  transferType: zod.enum(["stripe", "bank_transfer"]),
});

export const SendSellerPaymentLinkResponse = zod.object({
  url: zod.string().nullish(),
  bankDetails: zod.string().nullish(),
  plan: zod.string(),
  amount: zod.number(),
});

/**
 * @summary Submit a seller lead (public, no auth required)
 */
export const CreateSellerLeadBody = zod.object({
  name: zod.string(),
  phone: zod.string(),
  email: zod.string(),
  propertyArea: zod.string(),
  buildingProject: zod.string().optional(),
  propertyType: zod.string(),
  bedrooms: zod.string().optional(),
  askingPrice: zod.number(),
  mortgageOutstanding: zod.number().optional(),
  urgencyReason: zod.string(),
  timelineToSell: zod.string(),
  additionalNotes: zod.string().optional(),
  photoUrls: zod.string().optional(),
});

/**
 * @summary List seller leads (admin sees all; broker sees assigned)
 */
export const ListSellerLeadsQueryParams = zod.object({
  status: zod
    .enum([
      "new",
      "contacted",
      "valuation",
      "assigned",
      "active",
      "closed",
      "rejected",
    ])
    .optional(),
});

export const ListSellerLeadsResponseItem = zod.object({
  id: zod.number(),
  name: zod.string(),
  phone: zod.string(),
  email: zod.string(),
  propertyArea: zod.string(),
  buildingProject: zod.string().nullish(),
  propertyType: zod.string(),
  bedrooms: zod.string().nullish(),
  askingPrice: zod.number(),
  mortgageOutstanding: zod.number().nullish(),
  urgencyReason: zod.string(),
  timelineToSell: zod.string(),
  additionalNotes: zod.string().nullish(),
  photoUrls: zod.string().nullish(),
  status: zod.enum([
    "new",
    "contacted",
    "valuation",
    "assigned",
    "active",
    "closed",
    "rejected",
  ]),
  paymentStatus: zod.enum(["unpaid", "pending", "paid", "failed"]).nullish(),
  paymentPlan: zod.enum(["urgent_seller", "concierge_sale"]).nullish(),
  assignedAgentId: zod.number().nullish(),
  adminNotes: zod.string().nullish(),
  agentNotes: zod.string().nullish(),
  createdAt: zod.coerce.date(),
  updatedAt: zod.coerce.date().nullish(),
  assignedAgent: zod
    .object({
      id: zod.number(),
      name: zod.string(),
      email: zod.string(),
      phone: zod.string().nullish(),
      role: zod.enum(["admin", "broker", "investor"]),
      membership: zod.enum(["free", "vip", "elite"]),
      status: zod.enum(["pending", "approved", "rejected"]),
      paymentStatus: zod.enum(["unpaid", "pending", "paid", "failed"]),
      stripeCustomerId: zod.string().nullish(),
      createdAt: zod.coerce.date(),
    })
    .nullish(),
  aiLeadTemperature: zod.enum(["Hot", "Warm", "Cold"]).nullish(),
  aiUrgencyScore: zod.number().nullish(),
  aiLikelyMotivation: zod.string().nullish(),
  aiSuggestedAgentScript: zod.string().nullish(),
  aiRecommendedNextStep: zod.string().nullish(),
});
export const ListSellerLeadsResponse = zod.array(ListSellerLeadsResponseItem);

/**
 * @summary Get a seller lead by ID
 */
export const GetSellerLeadParams = zod.object({
  id: zod.coerce.number(),
});

export const GetSellerLeadResponse = zod.object({
  id: zod.number(),
  name: zod.string(),
  phone: zod.string(),
  email: zod.string(),
  propertyArea: zod.string(),
  buildingProject: zod.string().nullish(),
  propertyType: zod.string(),
  bedrooms: zod.string().nullish(),
  askingPrice: zod.number(),
  mortgageOutstanding: zod.number().nullish(),
  urgencyReason: zod.string(),
  timelineToSell: zod.string(),
  additionalNotes: zod.string().nullish(),
  photoUrls: zod.string().nullish(),
  status: zod.enum([
    "new",
    "contacted",
    "valuation",
    "assigned",
    "active",
    "closed",
    "rejected",
  ]),
  paymentStatus: zod.enum(["unpaid", "pending", "paid", "failed"]).nullish(),
  paymentPlan: zod.enum(["urgent_seller", "concierge_sale"]).nullish(),
  assignedAgentId: zod.number().nullish(),
  adminNotes: zod.string().nullish(),
  agentNotes: zod.string().nullish(),
  createdAt: zod.coerce.date(),
  updatedAt: zod.coerce.date().nullish(),
  assignedAgent: zod
    .object({
      id: zod.number(),
      name: zod.string(),
      email: zod.string(),
      phone: zod.string().nullish(),
      role: zod.enum(["admin", "broker", "investor"]),
      membership: zod.enum(["free", "vip", "elite"]),
      status: zod.enum(["pending", "approved", "rejected"]),
      paymentStatus: zod.enum(["unpaid", "pending", "paid", "failed"]),
      stripeCustomerId: zod.string().nullish(),
      createdAt: zod.coerce.date(),
    })
    .nullish(),
  aiLeadTemperature: zod.enum(["Hot", "Warm", "Cold"]).nullish(),
  aiUrgencyScore: zod.number().nullish(),
  aiLikelyMotivation: zod.string().nullish(),
  aiSuggestedAgentScript: zod.string().nullish(),
  aiRecommendedNextStep: zod.string().nullish(),
});

/**
 * @summary Update seller lead status, assignment, or notes (admin or assigned broker)
 */
export const UpdateSellerLeadParams = zod.object({
  id: zod.coerce.number(),
});

export const UpdateSellerLeadBody = zod.object({
  status: zod
    .enum([
      "new",
      "contacted",
      "valuation",
      "assigned",
      "active",
      "closed",
      "rejected",
    ])
    .optional(),
  assignedAgentId: zod.number().nullish(),
  adminNotes: zod.string().nullish(),
  agentNotes: zod.string().nullish(),
  paymentStatus: zod.enum(["unpaid", "pending", "paid", "failed"]).nullish(),
  paymentPlan: zod.enum(["urgent_seller", "concierge_sale"]).nullish(),
});

export const UpdateSellerLeadResponse = zod.object({
  id: zod.number(),
  name: zod.string(),
  phone: zod.string(),
  email: zod.string(),
  propertyArea: zod.string(),
  buildingProject: zod.string().nullish(),
  propertyType: zod.string(),
  bedrooms: zod.string().nullish(),
  askingPrice: zod.number(),
  mortgageOutstanding: zod.number().nullish(),
  urgencyReason: zod.string(),
  timelineToSell: zod.string(),
  additionalNotes: zod.string().nullish(),
  photoUrls: zod.string().nullish(),
  status: zod.enum([
    "new",
    "contacted",
    "valuation",
    "assigned",
    "active",
    "closed",
    "rejected",
  ]),
  paymentStatus: zod.enum(["unpaid", "pending", "paid", "failed"]).nullish(),
  paymentPlan: zod.enum(["urgent_seller", "concierge_sale"]).nullish(),
  assignedAgentId: zod.number().nullish(),
  adminNotes: zod.string().nullish(),
  agentNotes: zod.string().nullish(),
  createdAt: zod.coerce.date(),
  updatedAt: zod.coerce.date().nullish(),
  assignedAgent: zod
    .object({
      id: zod.number(),
      name: zod.string(),
      email: zod.string(),
      phone: zod.string().nullish(),
      role: zod.enum(["admin", "broker", "investor"]),
      membership: zod.enum(["free", "vip", "elite"]),
      status: zod.enum(["pending", "approved", "rejected"]),
      paymentStatus: zod.enum(["unpaid", "pending", "paid", "failed"]),
      stripeCustomerId: zod.string().nullish(),
      createdAt: zod.coerce.date(),
    })
    .nullish(),
  aiLeadTemperature: zod.enum(["Hot", "Warm", "Cold"]).nullish(),
  aiUrgencyScore: zod.number().nullish(),
  aiLikelyMotivation: zod.string().nullish(),
  aiSuggestedAgentScript: zod.string().nullish(),
  aiRecommendedNextStep: zod.string().nullish(),
});
